export default __webpack_public_path__ + "static/media/nammi_mobile.1bae79e5.jpg";